<template>
  <div class="weContainer q-pa-md" v-html="content"/>
</template>

<script>
import { useQueryStore } from '../stores/QueryStore.js'

export default {
  name: 'webentity',
  props: ['wedata', 'id', 'name', 'height', 'noDataLabel'],

  data() {
    return {
      webentity: null,
      content: "",
    }
  },

  methods: {

    fillPlaceholder() {
      if (this.webentity && this.webentity.content) {
        this.content = this.webentity.content
      }

      if (this.wedata) {
        Object.keys(this.wedata).forEach((keyname) => {
          let key = "[[" + keyname + "]]"
          this.content = this.content.replaceAll(key, this.wedata[keyname])
          //console.log("keyname:", key, "=", this.wedata[keyname])
        })
      } else {
        let emptymsg = (this.noDataLabel && this.noDataLabel != "") ? this.noDataLabel : this.$t('noWebentityDataFound')
        this.content = "<div>" + emptymsg + "</div>"
      }
    },

    appendScriptElementsToDocument() {
      let elList = document.getElementsByClassName('weContainer')
      let scriptList = []
      if (elList.length > 0) {
        let el = elList[0]
        scriptList = el.getElementsByTagName('script')

        // console.log(`found total of ${scriptList.length} script(s)...`, scriptList)

        let scriptSourceListDefine = []
        let scriptSourceListUse = []
        for (let i = 0; i < scriptList.length; i++) {
          if (!!scriptList[i].src) {
            scriptSourceListDefine.push(scriptList[i])
          } else {
            scriptSourceListUse.push(scriptList[i])
          }
        }

        for (let i = 0; i < scriptSourceListDefine.length; i++) {
          let source = scriptSourceListDefine[i].src
          let newScriptElementDefiningSource = document.createElement('script')
          newScriptElementDefiningSource.setAttribute('type', 'text/javascript')
          newScriptElementDefiningSource.src = source
          newScriptElementDefiningSource.addEventListener('load', () => {
            for (let i = 0; i < scriptSourceListDefine.length; i++) {
              let code = scriptSourceListUse[i].text
              let newScriptElementUsingSource = document.createElement('script')
              newScriptElementUsingSource.setAttribute('type', 'text/javascript')
              newScriptElementUsingSource.appendChild(document.createTextNode(code))
              document.body.appendChild(newScriptElementUsingSource)
            }
          })
          document.body.appendChild(newScriptElementDefiningSource)
        }
      } else {
        console.warn('no element with ID \'weContainer\' found')
      }
    }

  },

  watch: {
    wedata() {
      //this.fillPlaceholder()
    }
  }
  ,

  async mounted() {
    // console.log("now read webentity with name: ", this.name, ' / ID:', this.id)
    const queryStore = useQueryStore()
    if (this.id) {
      this.webentity = await queryStore.webEntityGet({webEntityID: this.id})

    } else if (this.name) {
      this.webentity = await queryStore.webEntityGet({webEntityName: this.name})
    }

    this.fillPlaceholder()
    //console.log("Webentity Mount Done.")

    this.$nextTick(() => {
      this.appendScriptElementsToDocument()
    })
  }
}
</script>

<style lang="sass">
.weContainer
  h1
    margin-top: 10px
    padding-top: 0
    line-height: 40px
    font-size: 40px
  user-select: text

</style>
